import { useQuery } from "@common/utils/use-query";
import { MigrationStore } from "./types";

export const migrationStore: MigrationStore = {
  useValidMigration(id, { enabled } = { enabled: false }) {
    return useQuery(`/migration/${id}/valid`, { enabled });
  },
};
